/* Chula — cookie consent
 *
 * Extracted from snippets/chula-consent.liquid on 2026-09-20.
 *
 * It was an inline <script> in the page body: re-sent and re-parsed on EVERY
 * page, never cached. As a theme asset it is fetched once and cached for the
 * session, and `defer` keeps it off the parser's critical path. The code is
 * the inline block verbatim, with Liquid comments turned into JS ones.
 */

/* ─────────────────────────────────────────────────────────────────────
     window.chulaDialogQueue

     Three first-visit dialogs used to land on one visitor inside ten
     seconds: Shopify's cookie banner at 0s, the region prompt at 1.2s
     (which locks the page), and the newsletter at 10s. This hands out
     turns instead, in priority order, one at a time.

     Anti-starvation, which is the whole difficulty, runs in both
     directions:

     - Downward. A slot only blocks the ones below it while it is still
       deciding. Every participant must call announce() or decline()
       exactly once; a WATCHDOG force-declines anything that has not
       reported within 2.5s, so a blocked script or a consent API that
       never loads cannot wedge the queue shut forever.

     - Upward. The newsletter passes its turn on any visit where another
       dialog already showed, which is what defers it to the next visit.
       Left alone that could repeat indefinitely (a visitor who never
       answers consent would never see it), so each suppression is
       counted and after DEFER_LIMIT the newsletter takes its turn
       regardless. The counter is written ONLY from the suppress branch —
       counting visits where it would not have shown anyway would burn it
       down and fire the newsletter on a visit that still had a live
       consent dialog.

     Slots are claimed synchronously during parse, so by the time the
     queue starts pumping it knows the full field and never waits on a
     dialog that isn't on this page.
     ───────────────────────────────────────────────────────────────────── */
  (function () {
    if (window.chulaDialogQueue) return;

    var ORDER = ['consent', 'region', 'newsletter'];
    var WATCHDOG_MS = 2500;
    var HOLD_MS = 90000;

    var slots = {};
    var active = null;
    var activeTimer = null;
    var shownAny = false;
    var started = false;

    function slot(id) {
      if (!slots[id]) slots[id] = { claimed: false, ready: false, run: null };
      return slots[id];
    }

    /* A dialog that takes a turn and never hands it back starves everything
       behind it — the exact failure the newsletter's own deferral counter
       cannot save it from, because a turn it never receives is a turn it
       cannot count. This happened for real: the region prompt reported that
       it had shown when the full locale panel was already open, so showGeo
       was a no-op and the queue sat holding a turn for a dialog that had
       never appeared.

       That specific cause is fixed at its source. This is the net under it.
       HOLD_MS is deliberately long — far longer than anyone spends reading a
       cookie dialog — because forcing a release early would let a second
       dialog open over one still on screen. Releasing late is harmless: the
       next dialog checks shownAny() and passes anyway. */
    function holdTimer(id) {
      clearTimeout(activeTimer);
      activeTimer = setTimeout(function () {
        if (active === id) {
          active = null;
          pump();
        }
      }, HOLD_MS);
    }

    function pump() {
      if (!started || active) return;

      for (var i = 0; i < ORDER.length; i++) {
        var s = slots[ORDER[i]];
        if (!s || !s.claimed) continue;
        // A higher-priority slot is still deciding — wait for it rather
        // than jumping the queue.
        if (!s.ready) return;
        if (s.run) {
          var fn = s.run;
          s.run = null;
          active = ORDER[i];
          var shown = false;
          try {
            shown = fn() !== false;
          } catch (e) {
            shown = false;
          }
          if (shown) {
            shownAny = true;
            holdTimer(ORDER[i]);
            return;
          }
          // It passed on its turn. Keep walking.
          active = null;
        }
      }
    }

    window.chulaDialogQueue = {
      /* Called synchronously at parse time by whichever dialogs exist. */
      claim: function (id) {
        slot(id).claimed = true;
      },
      /* "I want a turn." run() returns false to pass on it. */
      announce: function (id, run) {
        var s = slot(id);
        s.claimed = true;
        s.ready = true;
        s.run = run;
        pump();
      },
      /* "Nothing from me this visit." */
      decline: function (id) {
        var s = slot(id);
        s.claimed = true;
        s.ready = true;
        s.run = null;
        pump();
      },
      /* Called when a dialog closes, freeing the queue for the next. */
      release: function (id) {
        if (active === id) {
          active = null;
          clearTimeout(activeTimer);
        }
        pump();
      },
      /* Has anything actually shown on this page view? */
      shownAny: function () {
        return shownAny;
      },
      start: function () {
        if (started) return;
        started = true;
        pump();
      }
    };

    function begin() {
      window.chulaDialogQueue.start();
      setTimeout(function () {
        var forced = false;
        for (var i = 0; i < ORDER.length; i++) {
          var s = slots[ORDER[i]];
          if (s && s.claimed && !s.ready) {
            s.ready = true;
            s.run = null;
            forced = true;
          }
        }
        if (forced) pump();
      }, WATCHDOG_MS);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', begin);
    } else {
      begin();
    }
  })();

(function () {
    var root = document.getElementById('chula-consent');
    if (!root) return;

    var queue = window.chulaDialogQueue;
    var IN_EDITOR = !!(window.Shopify && window.Shopify.designMode);

    // Claim the slot synchronously so the region prompt waits for consent to
    // decide rather than racing it.
    if (queue && !IN_EDITOR) queue.claim('consent');

    var banner = document.getElementById('chula-consent-banner');
    var prefs = document.getElementById('chula-consent-prefs');
    var usRow = root.querySelector('[data-cc-us]');
    var switches = root.querySelectorAll('[data-cc-switch]');

    var scrollY = 0;
    var opener = null;
    var isOpen = false;
    var hideTimer = null;

    function api() {
      return window.Shopify && window.Shopify.customerPrivacy;
    }

    /* ── Page lock ──────────────────────────────────────────────────── */
    function lock(on) {
      if (on) {
        /* chulaPageLock FIRST: the open-class below carries position: fixed
           in CSS, and a lock that reads window.scrollY after the body is already
           fixed captures 0 — which returns the visitor to the top of the page on
           close. One implementation, one captured scroll position. */
        if (window.chulaPageLock) window.chulaPageLock.lock();
        scrollY = window.scrollY || window.pageYOffset || 0;
        var sbw = window.innerWidth - document.documentElement.clientWidth;
        // position:fixed + a negative top, because overflow:hidden alone does
        // not hold on iOS.
        document.body.style.top = -scrollY + 'px';
        if (sbw > 0) document.body.style.paddingRight = sbw + 'px';
        document.body.classList.add('chula-consent-open');
      } else {
        document.body.classList.remove('chula-consent-open');
        if (window.chulaPageLock) { window.chulaPageLock.unlock(); }
        else {
          document.body.style.top = '';
          document.body.style.paddingRight = '';
          window.scrollTo(0, scrollY);
        }
      }
    }

    /* ── Open / close ───────────────────────────────────────────────── */
    function open(view, from) {
      clearTimeout(hideTimer);
      opener = from || opener;

      banner.hidden = view !== 'banner';
      prefs.hidden = view !== 'prefs';
      root.hidden = false;

      if (!isOpen) {
        lock(true);
        isOpen = true;
      }

      // Never gate visibility on requestAnimationFrame: rAF does not fire in
      // a hidden or throttled tab, which would leave the page locked behind a
      // fully transparent overlay. A forced reflow is synchronous.
      void root.offsetHeight;
      root.classList.add('is-open');

      var card = view === 'prefs' ? prefs : banner;
      var target = card.querySelector('[data-cc-close]') || card.querySelector('button');
      if (target) {
        try {
          target.focus({ preventScroll: true });
        } catch (e) {
          target.focus();
        }
      }
    }

    function close() {
      if (!isOpen) return;
      isOpen = false;
      root.classList.remove('is-open');
      lock(false);

      hideTimer = setTimeout(function () {
        root.hidden = true;
        banner.hidden = true;
        prefs.hidden = true;
      }, 700);

      // Return focus to whatever opened us, with preventScroll — a plain
      // focus() scrolls the element into view and undoes the scroll position
      // the lock just restored.
      if (opener && document.contains(opener)) {
        try {
          opener.focus({ preventScroll: true });
        } catch (e) {}
      }
      opener = null;

      if (queue) queue.release('consent');
    }

    /* ── Writing consent ────────────────────────────────────────────── */
    function readSwitches() {
      var out = {};
      for (var i = 0; i < switches.length; i++) {
        var key = switches[i].getAttribute('data-cc-switch');
        // Never send sale_of_data outside a region that asks for it.
        if (key === 'sale_of_data' && usRow && usRow.hidden) continue;
        out[key] = switches[i].getAttribute('aria-checked') === 'true';
      }
      return out;
    }

    function setSwitches(on) {
      for (var i = 0; i < switches.length; i++) {
        switches[i].setAttribute('aria-checked', on ? 'true' : 'false');
      }
    }

    function write(consent) {
      var p = api();
      // setTrackingConsent must only ever run from a real interaction —
      // never on load, never to default someone in.
      if (p && typeof p.setTrackingConsent === 'function') {
        try {
          p.setTrackingConsent(consent, function () {});
        } catch (e) {}
      }
      close();
    }

    function acceptAll() {
      setSwitches(true);
      write(readSwitches());
    }

    function rejectAll() {
      setSwitches(false);
      write(readSwitches());
    }

    /* ── Wiring ─────────────────────────────────────────────────────── */
    root.addEventListener('click', function (e) {
      var t = e.target.closest('button');
      if (!t) return;

      if (t.hasAttribute('data-cc-accept')) return acceptAll();
      if (t.hasAttribute('data-cc-reject')) return rejectAll();
      if (t.hasAttribute('data-cc-save')) return write(readSwitches());
      if (t.hasAttribute('data-cc-prefs')) return open('prefs', t);
      if (t.hasAttribute('data-cc-close')) return close();

      if (t.hasAttribute('data-cc-switch')) {
        t.setAttribute('aria-checked', t.getAttribute('aria-checked') === 'true' ? 'false' : 'true');
      }
    });

    // No dismiss-by-scrim and no Escape on the first run: closing without a
    // decision would leave consent unrecorded and the queue held. Once a
    // choice exists, the panel is re-openable and Escape is fine.
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !isOpen) return;
      if (hasDecided()) close();
    });

    function hasDecided() {
      var p = api();
      if (!p || typeof p.currentVisitorConsent !== 'function') return false;
      try {
        var c = p.currentVisitorConsent() || {};
        return !!(c.analytics || c.marketing || c.preferences || c.sale_of_data);
      } catch (e) {
        return false;
      }
    }

    /* Footer link and anything else that wants to reopen it. */
    window.chulaOpenConsent = function (from) {
      var p = api();
      if (p && typeof p.currentVisitorConsent === 'function') {
        try {
          var c = p.currentVisitorConsent() || {};
          for (var i = 0; i < switches.length; i++) {
            var k = switches[i].getAttribute('data-cc-switch');
            switches[i].setAttribute('aria-checked', c[k] === 'yes' ? 'true' : 'false');
          }
        } catch (e) {}
      }
      open('prefs', from || null);
    };

    /* ── Decide whether to show on this visit ───────────────────────── */
    if (IN_EDITOR || !queue) return;

    var reported = false;
    function report(fn) {
      if (reported) return;
      reported = true;
      if (fn) queue.announce('consent', fn);
      else queue.decline('consent');
    }

    if (!(window.Shopify && typeof window.Shopify.loadFeatures === 'function')) {
      report(null);
    } else {
      // If the API never calls back, decline rather than holding the queue —
      // the watchdog would catch it, but this releases the region prompt
      // sooner and keeps the reason explicit.
      var bail = setTimeout(function () {
        report(null);
      }, 2000);

      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        function () {
          clearTimeout(bail);
          var p = api();
          if (!p) return report(null);

          try {
            if (typeof p.saleOfDataRegion === 'function' && p.saleOfDataRegion() && usRow) {
              usRow.hidden = false;
            }
          } catch (e) {}

          /* Ask everyone, everywhere, once — not only where consent is
             legally required.

             shouldShowBanner() is region-gated and returns false in plenty
             of places Shopify's own banner still appears: measured false in
             Hanoi (getRegion() === 'VNHN') while Shopify's white bar was on
             screen. Gating on it alone means a visitor there sees no banner
             from us at all, which is what "the design is completely
             different on a fresh load" turned out to be.

             Showing it where it is not required is never a violation — the
             risk only runs the other way — and it is what the Dior
             reference does. The cost is one dismissal for visitors in
             regions with no requirement.

             Set ASK_EVERYWHERE to false to go back to region-gated. */
          var ASK_EVERYWHERE = true;

          var show = false;
          try {
            // Don't gate on shouldShowBanner() alone: the docs and the field
            // reports disagree about whether it also accounts for consent
            // already being set. Checking both is correct under either.
            show = (ASK_EVERYWHERE || p.shouldShowBanner()) && !hasDecided();
          } catch (e) {
            show = false;
          }

          if (!show) return report(null);

          report(function () {
            // A breath after paint — a dialog that beats the page reads as
            // an ambush.
            setTimeout(function () {
              open('banner', null);
            }, 600);
            return true;
          });
        }
      );
    }
  })();

/* ─────────────────────────────────────────────────────────────────────
     Newsletter adapter

     Prestige's <newsletter-popup> schedules its own
     `setTimeout(() => this.show(), apparitionDelay)` in connectedCallback.
     Because that arrow calls `this.show()` at fire time rather than
     capturing it at schedule time, shadowing `show` on the instance is
     enough to route it through the queue — and it leaves the stock section
     untouched, so a Prestige update can't silently undo the patch.

     The rule: the newsletter passes its turn on any visit where another
     dialog already showed, which defers it to the next visit. Left there
     that could repeat forever — a visitor who never answers the cookie
     dialog would never see it — so each suppression is counted and after
     DEFER_LIMIT it takes its turn regardless.

     The counter is incremented ONLY when the queue actually suppressed it.
     Counting visits where it would not have shown anyway (wrong template,
     already filled, only-once already satisfied) would burn the allowance
     down and fire the newsletter on a visit that still had a live consent
     dialog — which is the exact pile-up this is here to prevent.
     ───────────────────────────────────────────────────────────────────── */
  (function () {
    var queue = window.chulaDialogQueue;
    if (!queue) return;
    if (window.Shopify && window.Shopify.designMode) return;

    var KEY = 'chula:nl-deferred';
    var DEFER_LIMIT = 2;

    function deferred() {
      try {
        return parseInt(localStorage.getItem(KEY) || '0', 10) || 0;
      } catch (e) {
        return 0;
      }
    }
    function bump() {
      try {
        localStorage.setItem(KEY, String(deferred() + 1));
      } catch (e) {}
    }
    function reset() {
      try {
        localStorage.removeItem(KEY);
      } catch (e) {}
    }

    function attach() {
      var nl = document.querySelector('newsletter-popup');
      if (!nl) return;

      queue.claim('newsletter');

      // A successful signup re-renders the element with `open` already set.
      // That is a returning submission showing its thank-you, not an
      // automatic appearance — don't queue it, or the confirmation vanishes.
      if (nl.hasAttribute('open')) {
        queue.decline('newsletter');
        return;
      }

      var realShow = nl.show;
      if (typeof realShow !== 'function') {
        queue.decline('newsletter');
        return;
      }

      /* THE ALLOWANCE MUST NOT CASH ITSELF IN ON THE HEELS OF ANOTHER DIALOG.

         The previous version read:

             if (queue.shownAny() && deferred() < DEFER_LIMIT) { bump(); pass }

         which means that on the visit where the allowance runs out, the
         `&&` fails and the newsletter shows — and release() pumps the queue
         the moment the consent panel closes, so it opened in the same frame
         the visitor clicked Accept. Reported as the cookie dialog "popping
         up twice even after you accept": two dialogs back to back, the
         second landing on the click that dismissed the first.

         The escape hatch is still needed — without it a visitor who is
         always shown something else would never see the newsletter — but it
         should buy a turn LATER IN THE SAME VISIT, not the next instant. So:
         if another dialog has shown, always pass now; once past the
         allowance, re-announce after a real gap and take the turn then, if
         the visitor is still here.

         REPRIEVE_MS is 45s: longer than the tail of any close animation and
         long enough that the newsletter reads as a separate moment rather
         than a second popup. */
      var REPRIEVE_MS = 45000;

      function takeTurn() {
        reset();
        realShow.call(nl);
        return true;
      }

      nl.show = function () {
        queue.announce('newsletter', function () {
          if (!queue.shownAny()) return takeTurn();

          /* Something else has already been put to her this visit. Pass — and
             count it, which is what eventually earns the reprieve below. */
          bump();

          if (deferred() > DEFER_LIMIT) {
            setTimeout(function () {
              /* Still nothing else on screen? Then take the turn. announce()
                 re-arms the slot; if a dialog is active, pump() parks this and
                 runs it when that one releases. */
              queue.announce('newsletter', takeTurn);
            }, REPRIEVE_MS);
          }

          return false;
        });
      };
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', attach);
    } else {
      attach();
    }
  })();
